import { render, staticRenderFns } from "./AspectNew.vue?vue&type=template&id=172026a6&scoped=true"
import script from "./AspectNew.vue?vue&type=script&lang=js"
export * from "./AspectNew.vue?vue&type=script&lang=js"
import style0 from "./AspectNew.vue?vue&type=style&index=0&id=172026a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172026a6",
  null
  
)

export default component.exports